import {Component, Input, AfterViewInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {AppUser} from '../AppUser';

@Component({
	selector: 'ui-download',
	template: `

		<div style="position: absolute;top:0;width:1px;visibility: hidden" *ngFor="let url of urls">

			<iframe style="position: absolute;top:0;width:1px;visibility: hidden" [src]="url" (load)="downloaded()"></iframe>
		</div>

		<div class="alert alert-warning" style="    position: fixed;bottom: 0;left: 0; z-index: 10000;margin: 0px;"
			 [hidden]="downloading==0">
			Downloading {{downloading}} File{{downloading > 1 ? 's' : ''}}
			<div class="glyphicon glyphicon-download"></div>
		</div>
	`
	//
})


export class UIDirectiveDownload {

	public urls: SafeResourceUrl[] = [];
	public downloading = 0;

	public constructor(public sanitizer: DomSanitizer, public appUser: AppUser) {
	}

	download(url,addToken = true) {
		console.log('download',{url,addToken});
		this.downloading++;
		this.urls.push(this.sanitizer.bypassSecurityTrustResourceUrl(url +(addToken? '?token=' + this.appUser.getToken():'')));
	}

	downloaded() {
		console.log('downloaded');
		setTimeout(none => {
			this.downloading--;
		}, 1000);
	}
}
